import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { useUserInfoStore } from '@pascal/pascal-core';
import WinnerContentItem from '../winnerContentItem';

const WinnerContent = observer(({ winnersData }) => {
  const { userId } = useUserInfoStore();

  const { userBets, otherBets } = useMemo(
    () => ({
      userBets: winnersData.filter((winner) => +userId === winner.userId),
      otherBets: winnersData.filter((winner) => +userId !== winner.userId),
    }),
    [userId, winnersData]
  );

  return (
    <div className='c-m-winner-content'>
      <div className='c-m-winner-content-holder'>
        <div className='c-m-winner-content-inner'>
          <WinnerContentItem data={userBets} />
          <WinnerContentItem data={otherBets} />
        </div>
      </div>
    </div>
  );
});

export default WinnerContent;
